import purse_banner from '../../images/events/PurseBingoPoster.png';

function PurseBingo() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h1>Purse Bingo for Charity</h1>
      <h2>Friday, January 29, 2027</h2>
      <a href="/purse">
        <h2>Purchase Tickets for the Event</h2>
      </a>
      <a href="">
        <img
          src={purse_banner}
          className="text-center responsive-img"
          alt="Purse Bingo"
          style={{ maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto' }}
        />
      </a>
    </div>
  );
}

export default PurseBingo;
